import { GeofencesIndexPage, GeofencesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { generatePath } from '@/services/router/generate-path';

function GeofencesIndexRoute() {
  return (
    <GeofencesRoute
      permission="journeys/geofences/view"
      redirectTo={(params) =>
        generatePath('/workspaces/:workspaceId/journeys', { workspaceId: params.workspaceId ?? 0 })
      }
    >
      <GeofencesIndexPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/')({
  component: GeofencesIndexRoute,
});
